module.exports = "label{top:0}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/login-with-otp/login-with-otp.component.css
// module id = ./src/app/shared/login-with-otp/login-with-otp.component.css
// module chunks = main